import { useMemo } from 'react';
import { FeedbackUIAction, publish, TCoreEvents } from '@fe-core-events';
import { useIntl } from 'react-intl';
import { TDisenrollmentStatus } from '@api/io/session.disenrollment.io';

export const useDisenrollmentFeedback = ({
  disenrollmentStatus,
}: {
  disenrollmentStatus?: TDisenrollmentStatus | null;
}) => {
  const intl = useIntl();

  const eventMap: Record<
    TDisenrollmentStatus,
    {
      eventType: 'warning' | 'info' | 'success';
      eventAction: FeedbackUIAction;
      title: string;
      description: string;
    }
  > = useMemo(() => {
    const closeAction = {
      event: '',
      type: 'close' as const,
      text: {
        title: intl.formatMessage({ id: 'learner.common.close' }),
      },
    };
    return {
      ok: {
        eventType: 'info',
        title: 'catalog.course.disenroll.confirmation.ok.title',
        description: 'catalog.course.disenroll.confirmation.ok.description',
        eventAction: closeAction,
      },
      notfound: {
        eventType: 'info',
        title: 'catalog.course.disenroll.confirmation.notfound.title',
        description:
          'catalog.course.disenroll.confirmation.notfound.description',
        eventAction: closeAction,
      },
      disabled: {
        eventType: 'info',
        title: 'catalog.course.disenroll.confirmation.disabled.title',
        description:
          'catalog.course.disenroll.confirmation.disabled.description',
        eventAction: closeAction,
      },
      unknown: {
        eventType: 'warning',
        title: 'catalog.course.disenroll.confirmation.unknown.title',
        description:
          'catalog.course.disenroll.confirmation.unknown.description',
        eventAction: closeAction,
      },
    };
  }, [intl]);

  if (!disenrollmentStatus) {
    return;
  }

  const eventDetails = eventMap[disenrollmentStatus];
  const eventName = `feedback.ui.${eventDetails.eventType}.base` as TCoreEvents;
  publish({
    eventName,
    data: {
      consumer: 'fe-learner-catalog',
      event: eventName,
      type: 'modal',
      status: eventDetails.eventType,
      config: {
        title: intl.formatMessage({ id: eventDetails.title }),
        description: intl.formatMessage({ id: eventDetails.description }),
      },
      action: eventDetails.eventAction,
    },
  });
};
